import React from "react";
import {
  UseFormRegister,
  FieldErrors,
  UseFormSetValue,
  UseFormClearErrors,
} from "react-hook-form";
import Input from "../../../components/Input";
import SelectInput from "../../../components/Select";
import {
  OrderFormData,
  PAYMENT_TYPE_OPTIONS,
  ORDER_SHIPMENT_TYPE_OPTIONS,
} from "../../../types/types";
import { useServiceAllListData } from "../../../apis/orderApis";
import TextareaField from "../../../components/common/TextareaField";

interface ShipmentSectionProps {
  register: UseFormRegister<OrderFormData>;
  open: boolean;
  onClose: () => void;
  errors: FieldErrors<OrderFormData>;
  setValue: UseFormSetValue<OrderFormData>;
  watch: any;
  clearErrors: UseFormClearErrors<OrderFormData>;
  mode: "add" | "view";
  setMode: (mode: "add" | "view") => void;
}

const ShipmentSection: React.FC<ShipmentSectionProps> = ({
  register,
  errors,
  setValue,
  watch,
  clearErrors,
  mode,
  open,
}) => {
  const { data } = useServiceAllListData();

  return (
    <div className="grid grid-cols-4 gap-2 bg-[#FFFFFF] p-4 rounded-xl shadow-md h-fit">
      <p className="text-[#212121]/70 font-medium col-span-4 pb-2">
        Shipment Details
      </p>
      <Input
        name="shipment.referenceNumber"
        type="text"
        title="Reference"
        register={register}
        error={errors.shipment?.referenceNumber}
        validation={{
              required: "Reference is required",
              minLength: {
                value: 4,
                message: "Reference must be at least 4 characters",
              },
              maxLength: {
                value: 10,
                message: "Reference cannot exceed 10 characters",
              },
            }}
            other={{
              onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                let value = e.target.value.replace(/\D/g, "");
                if (value.length > 10) {
                  value = value.slice(0, 10);
                }
                setValue("shipment.referenceNumber", value, {
                  shouldValidate: true,
                  shouldDirty: true,
                });
              },
            }}
        className=""
      />

      <SelectInput
        name="shipment.shipmentType"
        label="Shipment Type"
        className=""
        placeholder="Select Shipment Type"
        selectOptions={ORDER_SHIPMENT_TYPE_OPTIONS}
        clearErrors={clearErrors}
        register={register}
        validation={{ required: "Shipment type is required" }}
        value={watch("shipment.shipmentType")}
        setValue={(val: string) => {
          setValue("shipment.shipmentType", val);
        }}
      />

      <SelectInput
        name="shipment.serviceType"
        label="Service"
        className=""
        placeholder="Select Service"
        selectOptions={
          data?.map((service: any) => ({
            id: service?.id,
            value: service?.name,
            text: service?.name,
          })) || []
        }
        clearErrors={clearErrors}
        register={register}
        validation={{ required: "Service is required" }}
        value={watch("shipment.serviceType")}
        setValue={(val: string) => {
          setValue("shipment.serviceType", val);
        }}
      />

      <Input
        name="shipment.numberOfPieces"
        type="number"
        title="No of Pieces"
        register={register}
        error={errors.shipment?.numberOfPieces}
        validation={{
          required: "No of pieces is required",
          min: { value: 1, message: "Must be at least 1" },
        }}
        className=""
      />

      <Input
        name="shipment.totalWeight"
        type="number"
        title="Total Weight (kg)"
        register={register}
        error={errors.shipment?.totalWeight}
        validation={{
          required: "Total weight is required",
          pattern: {
            value: /^\d*\.?\d*$/,
            message: "Must be a valid number",
          },
        }}
        className=""
      />

      <Input
        name="shipment.shipmentCost"
        type="text"
        title="Shipment Cost"
        register={register}
        error={errors.shipment?.shipmentCost}
        validation={{ required: "Shipment cost is required" }}
        className=""
      />

      {/* <SelectInput
        name="shipment.paymentType"
        label="Payment Type"
        className=""
        placeholder="Select Payment Type"
        selectOptions={PAYMENT_TYPE_OPTIONS}
        clearErrors={clearErrors}
        register={register}
        value={watch("shipment.paymentType")}
        setValue={(val: string) => {
          setValue("shipment.paymentType", val);
          if (val !== "COD") {
            setValue("shipment.codAmount", "");
          }
        }}
        validation={{ required: "Payment Type is required" }}
      />

      {watch("shipment.paymentType") === "COD" && (
        <Input
          name="shipment.codAmount"
          type="number"
          title="COD Amount"
          register={register}
          error={errors.shipment?.codAmount}
          validation={{ required: "COD amount is required" }}
          className=""
        />
      )} */}

      <TextareaField
        rows={1}
        className="col-span-2"
        label="Description"
        register={register}
        placeholder=""
        name="shipment.description"
        error={errors.shipment?.description}
        validation={{ required: "Description is required" }}
      />
    </div>
  );
};

export default ShipmentSection;
